import React, { useState } from 'react';
import './Contact.css';
import { FaInstagram, FaFacebook } from 'react-icons/fa';

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const data = Object.fromEntries(formData.entries());

    try {
      const response = await fetch('https://firehousespirits.store/n8n/webhook/f39edb09-da9c-4b57-aaf0-776bf0f3c18f', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Basic d2Vic3RvcmU6RURlOHJpSDU2WDF2YUliQjJxWjNBQ2cxTTNSZEgxYVMwN2VnaTRQM3hKSEM2NDdLYXA='
        },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        setSubmitted(true);
      } else {
        alert('There was an error submitting your enquiry. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('There was an error submitting your enquiry. Please try again.');
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-left">
        <h2>CONTACT US</h2>
        <p>
          We are here to assist. Whether you have a question about our small batch collection, an issue with a pre-order, or simply wish to connect, this is your direct line to the house.
        </p>
        <p>
          We read and respond to every message personally.
        </p>
        {submitted ? (
          <p>Thank you for your enquiry. We will be in touch shortly.</p>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Your Name *</label>
              <input type="text" id="name" name="name" required />
            </div>
            <div className="form-group">
              <label htmlFor="email">Your Email *</label>
              <input type="email" id="email" name="email" required />
            </div>
            <div className="form-group">
              <label htmlFor="subject">Subject *</label>
              <select id="subject" name="subject" required defaultValue="">
                <option value="" disabled>Select a subject</option>
                <option value="Pre-Order Enquiry">Pre-Order Enquiry</option>
                <option value="Launch Event Question">Launch Event Question</option>
                <option value="General Question">General Question</option>
                <option value="Trade Enquiry">Trade Enquiry</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="message">Your Message *</label>
              <textarea id="message" name="message" rows="5" required></textarea>
            </div>
            <button type="submit">SUBMIT YOUR ENQUIRY</button>
          </form>
        )}
      </div>
      <div className="contact-right">
        <h3>TRADE & PRESS ENQUIRIES</h3>
        <p>
          For all wholesale, stocking, or media enquiries, please contact us directly. We are always looking for new partners who share our dedication to quality.
        </p>
        <p>Email: <a href="mailto:trade@firehousespirits.store">trade@firehousespirits.store</a></p>
        <h3>JOIN THE CONVERSATION</h3>
        <p>
          For the latest news, product reveals, and a look behind the scenes, follow us on social media.
        </p>
        <div className="social-links">
          <a href="https://www.instagram.com/firehousespirits" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          <a href="https://www.facebook.com/firehousespirits" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
